import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Searchbar.css";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";

const Searchbar = ({ clubs = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const displayCount = 8;
  const nav = useNavigate();
  const inputRef = useRef(null); // Create a reference to the input element
  const { t } = useTranslation();

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    if (isModalOpen && inputRef.current) {
      inputRef.current.focus(); // Focus the input element when the modal opens
    }
  }, [isModalOpen]);

  const filteredClubs = clubs
    .filter((club) =>
      club.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .slice(0, displayCount);

  return (
    <div>
      <div className="searchButton">
        <input
          type="text"
          readOnly
          name="search"
          value={`${t('search')}...`}
          onClick={toggleModal}
          className="search-input-button"
        />
        <SearchIcon className="search-icon" onClick={toggleModal} />
      </div>
      {isModalOpen && (
        <div className="modal" onClick={toggleModal}>
          <div className="modal-popup" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={toggleModal}>
              &times;
            </span>
            <div className="modal-content">
              <input
                ref={inputRef}
                className="search-input"
                type="text"
                placeholder={t('search_placeholder')}
                value={searchTerm}
                onChange={handleSearch}
              />
              <ul>
                {filteredClubs.map((club) => (
                  <li key={club.handle}>
                    <p
                      onClick={() => {
                        nav(`/${club.handle}`, {
                          state: { ClubsList: clubs },
                        });
                        toggleModal();
                        setSearchTerm("");
                      }}
                    >
                      {club.name}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Searchbar;
